import React from "react";
import './CardsHeader.scss'
import Text from "../../../../../components/Atomsv2/Text/Text";
import Skeleton from "../../../../../components/Atomsv2/Skeleton/Skeleton";
import CardDashboard from "../../../../../components/moleculesv2/DashboardCard/CardDashboard";
import { traerSemana } from "../../AdministracionSemaforoIntegracion";
import InfoTooltip from "../../../../../components/molecules/InfoTooltip/InfoTooltip";
import { formatearMiles } from "../../../../../utilidades/formateos";

const CardDashboardV2 = ({ loading, data }) => {

    const semanaActual = traerSemana().semana;
    const dataSemanaAnterior = data?.filter(d => d.SEMANA === semanaActual - 1) ?? []
    // incidentes
    let incidentes = {
        total: null,
        administrativos: null,
        operativos: null,
        totalSemanaAnterior: null,
    }
    incidentes.total = data?.reduce((acc, item) => acc + item.INCIDENTES_TOTAL, 0) ?? 0
    incidentes.operativos = data?.reduce((acc, item) => acc + item.INCIDENTES_OPERATIVOS, 0) ?? 0
    incidentes.administrativos = data?.reduce((acc, item) => acc + item.INCIDENTES_ADMINISTRATIVOS, 0) ?? 0
    incidentes.totalSemanaAnterior = dataSemanaAnterior?.reduce((acc, item) => acc + item.INCIDENTES_TOTAL, 0) ?? 0
   
    // facturacion
    let facturacion = {
        real: null,
        estimada: null,
        diferencia: null,
    }
    facturacion.real = data?.reduce((acc, item) => acc + item.FACTURACION_REAL, 0) ?? 0
    facturacion.estimada = data?.reduce((acc, item) => acc + item.FACTURACION_ESTIMADA, 0) ?? 0
    facturacion.diferencia = data?.reduce((acc, item) => acc + item.DIFERENCIA_FACTURACION, 0) ?? 0


    // servicios realizados
    let servicios = {
        ejecutados: null,
        cancelados: null,
        noEjecutados: null,
        solicitados: null,
        programados: null,
        semanaAnterior: null,
    }
    servicios.ejecutados = data?.reduce((acc, item) => acc + item.SERVICIOS_EJECUTADOS_TOTAL, 0) ?? 0
    servicios.cancelados = data?.reduce((acc, item) => acc + item.SERVICIOS_CANCELADOS, 0) ?? 0
    servicios.noEjecutados = data?.reduce((acc, item) => acc + item.SERVICIOS_NO_EJECUTADOS, 0) ?? 0
    servicios.solicitados = data?.reduce((acc, item) => acc + item.SERVICIOS_SOLICITADOS_TOTAL, 0) ?? 0
    servicios.programados = data?.reduce((acc, item) => acc + item.SERVICIOS_PROGRAMADOS_COBRABLES, 0) ?? 0



    const _eficienciaValida = data?.filter(item => item.EFICIENCIA_OPERATIVA_PCT != null) ?? [];
    const promedioNivelServicio = _eficienciaValida.length > 0
        ? _eficienciaValida.reduce((acc, item) => acc + item.EFICIENCIA_OPERATIVA_PCT, 0) / _eficienciaValida.length
        : 0;

    const _eficienciaValidaAnterior = dataSemanaAnterior?.filter(item => item.EFICIENCIA_OPERATIVA_PCT != null) ?? [];
    const promedioNivelServicioSemanaAnterior = _eficienciaValidaAnterior.length > 0
        ? _eficienciaValidaAnterior.reduce((acc, item) => acc + item.EFICIENCIA_OPERATIVA_PCT, 0) / _eficienciaValidaAnterior.length
        : 0;
    const serviciosRealizadosSemanaAnterior = dataSemanaAnterior?.reduce((acc, item) => acc + item.SERVICIOS_EJECUTADOS_TOTAL, 0) ?? 0

    const footer = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <Text color={incidentes.totalSemanaAnterior > 0 ? 'var(--red-600)' : 'var(--blue-600)'} weight={"600"} size={"small"}>
                    {incidentes.totalSemanaAnterior > 0 ? `(${incidentes.totalSemanaAnterior.toFixed(2)}%)` : `(${incidentes.totalSemanaAnterior.toFixed(2)}%)`} Respecto a la semana anterior
                </Text>
            </div>
        )
    }
    const footerService = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <span
                    className="icon"
                    data-icon={promedioNivelServicioSemanaAnterior < 0 ? "trending_down" : "trending_up"}
                    style={{ color: promedioNivelServicioSemanaAnterior < 0 ? 'var(--red-600)' : 'var(--green-600)', fontSize: '28px' }}
                />
                <Text color={promedioNivelServicioSemanaAnterior < 0 ? 'var(--red-600)' : 'var(--blue-600)'} weight={"600"} size={"small"}>
                    {promedioNivelServicioSemanaAnterior < 0 ? `(${promedioNivelServicioSemanaAnterior.toFixed(2)}%)` : `(${promedioNivelServicioSemanaAnterior.toFixed(2)}%)`} Respecto a la semana anterior
                </Text>
            </div>
        )
    }
    const footerRealizados = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <Text color={servicios.semanaAnterior < 0 ? 'var(--red-600)' : 'var(--blue-600)'} weight={"600"} size={"small"}>
                    {servicios.semanaAnterior < 0 ? `(${servicios.semanaAnterior.toFixed(2)}%)` : `(${servicios.semanaAnterior.toFixed(2)}%)`} Respecto a la semana anterior
                </Text>
            </div>
        )
    }

    return (
        <div className="CardsHeader">
            {
                loading ?
                    <>
                        <Skeleton width={'400px'} height={145} />
                        <Skeleton width={'400px'} height={145} />
                        <Skeleton width={'400px'} height={145} />
                        <Skeleton width={'400px'} height={145} />
                    </>
                    :
                    <>
                        {/* real: null,
        estimada: null,
        diferencia: null, */}
                        <InfoTooltip
                            icon="attach_money"
                            title="DESGLOSE DE FACTURACION"
                            className="info-tooltip-semaforo"
                            trigger={
                                <CardDashboard
                                    title="Facturación calculada en ejecución"
                                    icon="attach_money"
                                    iconColor={'var(--green-600)'}
                                    iconSize={'20px'}
                                // footer={footer()}
                                >
                                    <Text weight={"800"} size={"medium-large"}>
                                        {facturacion.real.toLocaleString("es-MX", {
                                            style: "currency",
                                            currency: "MXN",
                                        })}
                                    </Text>
                                </CardDashboard>
                            }
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="check" style={{ color: 'var(--green-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Facturación estimada: {facturacion.estimada.toLocaleString("es-MX", {
                                            style: "currency",
                                            currency: "MXN",
                                        })}
                                    </Text>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="stat_minus_1" style={{ color: 'var(--red-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Facturación diferencia: {facturacion.diferencia.toLocaleString("es-MX", {
                                            style: "currency",
                                            currency: "MXN",
                                        })}
                                    </Text>
                                </div>
                            </div>

                        </InfoTooltip>
                        <InfoTooltip
                            icon="warning"
                            title="DESGLOSE DE INCIDENTES"
                            className="info-tooltip-semaforo"
                            trigger={
                                <CardDashboard
                                    title="Total de Incidentes"
                                    // icon="alert"
                                    iconColor={'var(--yellow-600)'}
                                    iconSize={'20px'}
                                // footer={footer()}
                                >
                                    <Text weight={"800"} size={"medium-large"}>
                                        {formatearMiles(incidentes.total)}
                                    </Text>
                                </CardDashboard>
                            }
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="warning" style={{ color: 'var(--yellow-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Incidentes Operativos: {formatearMiles(incidentes.operativos)}
                                    </Text>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="warning" style={{ color: 'var(--yellow-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Incidentes Administrativos: {formatearMiles(incidentes.administrativos)}
                                    </Text>
                                </div>
                            </div>

                        </InfoTooltip>

                        {/* -----------------------------------------------------------------------------------nivel de servicios */}
                        <CardDashboard
                            title="Nivel de Servicio"
                            icon="grouped_bar_chart"
                            iconColor={'var(--blue-600)'}
                            iconSize={'20px'}
                        // footer={footerService()}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <Text weight={"800"} size={"medium-large"}>
                                    {Math.abs(promedioNivelServicio).toFixed(2)} %
                                </Text>
                            </div>
                        </CardDashboard>
                        <InfoTooltip
                            icon="check_circle_unread"
                            title="DESGLOSE DE SERVICIOS"
                            className="info-tooltip-semaforo"
                            trigger={
                                <CardDashboard
                                    title="Servicios Realizados"
                                    icon="check_circle_unread"
                                    iconColor={'var(--blue-600)'}
                                    iconSize={'20px'}
                                // footer={footerRealizados()}
                                >
                                    <Text weight={"800"} size={"medium-large"}>
                                        {formatearMiles(servicios.ejecutados)}

                                    </Text>
                                </CardDashboard>
                            }
                        >

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="check" style={{ color: 'var(--green-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Servicios cancelados:  {formatearMiles(servicios.cancelados)}
                                    </Text>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="check" style={{ color: 'var(--green-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Servicios no ejecutados:  {formatearMiles(servicios.noEjecutados)}
                                    </Text>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="check" style={{ color: 'var(--green-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Servicios solicitados:  {formatearMiles(servicios.solicitados)}
                                    </Text>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="icon" data-icon="check" style={{ color: 'var(--green-600)', fontSize: '20px' }} />
                                    <Text weight={"600"} size={"small"}>
                                        Servicios programados:  {formatearMiles(servicios.programados)}
                                    </Text>
                                </div>
                            </div>
                        </InfoTooltip>
                    </>
            }
        </div>
    )


}
export default CardDashboardV2